export default "__VITE_ASSET__BhOcNjWW__"